var minjas = 125;
var goodjas = 200;
var minbarva = 500;
var goodbarva = 550;

function check(rgb, el)
{
	if (rgb == 1)
	{
		if (/\D+/.test(el.value)) el.value = el.value.replace(/\D+/g, "");
		if (el.value > 255) el.value = 255;
		if (el.value.length > 0) kontrast(1)
	}
	else
	{
		if (/[^A-Fa-f0-9]+/.test(el.value)) el.value = el.value.replace(/[^A-Fa-f0-9]+/g, "");
		if (el.value.length == 3 || el.value.length == 6) kontrast(0)
	}
}

function kontrast(rgb)
{
	var text = document.getElementById("textColor");
	var textR = document.getElementById("textColorR");
	var textG = document.getElementById("textColorG");
	var textB = document.getElementById("textColorB");

	var pozadi = document.getElementById("backgroundColor");
	var pozadiR = document.getElementById("backgroundColorR");
	var pozadiG = document.getElementById("backgroundColorG");
	var pozadiB = document.getElementById("backgroundColorB");

	if (rgb == 1)
	{

		if (textR.value.length != 0 && textG.value.length != 0 && textB.value.length != 0 && pozadiR.value.length != 0 && pozadiG.value.length != 0 && pozadiB.value.length != 0)
		{
			textR = parseInt(textR.value);
			textG = parseInt(textG.value);
			textB = parseInt(textB.value);
			pozadiR = parseInt(pozadiR.value);
			pozadiG = parseInt(pozadiG.value);
			pozadiB =
				parseInt(pozadiB.value);
			jastext = round(0.299 * textR + 0.587 * textG + 0.114 * textB);
			jaspozadi = round(0.299 * pozadiR + 0.587 * pozadiG + 0.114 * pozadiB);
			jasrozdil = Math.abs(jastext - jaspozadi);
			jasrozdil = round(jasrozdil);
			barvy = Math.abs(textR + textG + textB - (pozadiR + pozadiG + pozadiB));
			barvy = round(barvy);

			updatebar( "jastext2", jastext, 255);
			updatebar( "jaspozadi2", jaspozadi, 255);
			updatebar( "jasrozdil2", jasrozdil, 255);
			updatebar( "barvy2", barvy, 765);

			var kontrast = textkontrast(jasrozdil, barvy);
			updatebar( "kontrast2", kontrast[0], 4, kontrast[1]);

			var ukazka2 = document.getElementById("ukazka2");
			ukazka2.style.background = "rgb(" + pozadiR + ", " + pozadiG + ", " + pozadiB + ")";
			ukazka2.style.color = "rgb(" + textR + ", " + textG + ", " + textB + ")";
		}
	}
	else if ((text.value.length == 3 || text.value.length == 6) && (pozadi.value.length == 6 || pozadi.value.length == 3))
	{
		text.value = text.value.toUpperCase();
		if (text.value.length == 6)
		{
			textR = hextorgb(text.value[0]);
			textG = hextorgb(text.value[2]);
			textB = hextorgb(text.value[4]);
			textR = textR * 16 + hextorgb(text.value[1]);
			textG = textG * 16 + hextorgb(text.value[3]);
			textB = textB * 16 + hextorgb(text.value[5])
		}
		else if (text.value.length == 3)
		{
			textR = hextorgb(text.value[0]);
			textG = hextorgb(text.value[1]);
			textB = hextorgb(text.value[2]);
			textR = textR * 16 + textR;
			textG = textG * 16 + textG;
			textB = textB * 16 + textB
		}
		pozadi.value = pozadi.value.toUpperCase();
		pozadiR = hextorgb(pozadi.value[0]);
		pozadiG = hextorgb(pozadi.value[2]);
		pozadiB = hextorgb(pozadi.value[4]);
		if (pozadi.value.length == 6)
		{
			pozadiR = pozadiR * 16 + hextorgb(pozadi.value[1]);
			pozadiG = pozadiG * 16 + hextorgb(pozadi.value[3]);
			pozadiB = pozadiB * 16 + hextorgb(pozadi.value[5])
		}
		else if (pozadi.value.length == 3)
		{
			pozadiR = hextorgb(pozadi.value[0]);
			pozadiG = hextorgb(pozadi.value[1]);
			pozadiB = hextorgb(pozadi.value[2]);
			pozadiR = pozadiR * 16 + pozadiR;
			pozadiG = pozadiG * 16 + pozadiG;
			pozadiB = pozadiB * 16 + pozadiB
		}
		jastext = round(0.299 * textR + 0.587 * textG + 0.114 * textB);
		jaspozadi =
			round(0.299 * pozadiR + 0.587 * pozadiG + 0.114 * pozadiB);
		jasrozdil = Math.abs(jastext - jaspozadi);
		jasrozdil = round(jasrozdil);
		barvy = Math.abs(textR + textG + textB - (pozadiR + pozadiG + pozadiB));
		barvy = round(barvy);

		updatebar( "jastext1", jastext, 255);
		updatebar( "jaspozadi1", jaspozadi, 255);
		updatebar( "jasrozdil1", jasrozdil, 255);
		updatebar( "barvy1", barvy, 765);

		var kontrast = textkontrast(jasrozdil, barvy);
		updatebar( "kontrast1", kontrast[0], 4, kontrast[1]);

		var ukazka1 = document.getElementById("ukazka1");
		ukazka1.style.color = "#" + text.value;
		ukazka1.style.background = "#" + pozadi.value;
	}
}

function updatebar(id, value, max, text)
{
	var element = document.getElementById(id);
	element.style.width = (value / max * 100) + "%";
	element.innerText = text || value;
}

function hextorgb(value)
{
	return parseInt(value, 16);
}

function textkontrast(jasvalue, barvyvalue)
{
	if (jasvalue >= goodjas && barvyvalue >= goodbarva) return [4, "v\u00fdborn\u00fd"];
	else if (jasvalue >= goodjas && barvyvalue >= minbarva) return [3, "dobr\u00fd"];
	else if (jasvalue >= minjas && barvyvalue >= goodbarva) return [2, "dobr\u00fd"];
	else if (jasvalue >= minjas && barvyvalue >= minbarva) return [1, "dostate\u010dn\u00fd"];
	else if (jasvalue < minjas || barvyvalue < minbarva) return [0, "nedostate\u010dn\u00fd"];
	else return [0, "?"];
}

function round(num) {return Math.round(num * 100) / 100};
